<template>
  <div class="index">
    <div class="content">
      <el-row :gutter="32">
        <el-col :span="24"><img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/index1.png" /></el-col>
      </el-row>
      <el-row :gutter="32">
        <el-col :span="24"><img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon1.png" /></el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>
<style scoped>
  .flex{display: flex; justify-content: space-between;align-items: center;}
  .img{width: 100%;height: auto}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue